import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { StartCountSessionDraft } from "~count/lines/helpers/countSessionJobHelpers";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import isRecord from "~/helpers/isRecord";

export const LINE_SOURCE_KIND = "productionLine";

export const LINE_TARGET_KIND = "productionLine";

export const LINES_BASE_PATH = "/count/lines";

export const LINES_DOCK_PANEL_ID = "lines";

const LINE_ROUTE_PATTERN = /^\/count\/lines\/([^/?#]+)$/;

export interface LineSourceCheckpoint {
	lineCode: string;
	lineId: string;
	pickedDeviceId: null | string;
	startDraft?: StartCountSessionDraft;
}

const isNullableNumber = (value: unknown) => value === null || typeof value === "number";

const isStartCountSessionDraft = (value: unknown): value is StartCountSessionDraft =>
	isRecord(value) &&
	typeof value.countSessionId === "string" &&
	(value.productionJobId === null || typeof value.productionJobId === "string") &&
	isNullableNumber(value.crew) &&
	isNullableNumber(value.target);

export const isLineSourceCheckpoint = (value: unknown): value is LineSourceCheckpoint =>
	isRecord(value) &&
	typeof value.lineId === "string" &&
	typeof value.lineCode === "string" &&
	(value.pickedDeviceId === null || typeof value.pickedDeviceId === "string") &&
	(value.startDraft === undefined || isStartCountSessionDraft(value.startDraft));

export const lineEditorKey = (lineId: string): string => `production-line:${lineId}`;

export const buildLinePath = (lineId: string): string => `${LINES_BASE_PATH}/${encodeURIComponent(lineId)}`;

export const matchLineReceiverRoute = (pathname: string): ContinuationTarget | null => {
	const match = LINE_ROUTE_PATTERN.exec(pathname);
	return match ? { targetId: decodeURIComponent(match[1]), targetKind: LINE_TARGET_KIND } : null;
};

const lineReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => buildLinePath(targetId),
	matchesRoute: matchLineReceiverRoute
};

export default lineReceiverIdentityAdapter;
